import $ from 'jquery';
var jQuery = require("jquery");
window.jQuery = $;

// html js class
$('html').toggleClass('no-js js');

import './modules/header';
import './modules/lazyloading';
import 'bootstrap/js/src/collapse';

$('#main-nav').on('show.bs.collapse	hide.bs.collapse', (e) => {
    console.log('open');
    let header = $(e.currentTarget).closest('.site-header');
    header.toggleClass('site-header--open');
});

// load more
import { ajaxLoader } from './modules/ajaxLoader';
let loader = new ajaxLoader();

// custom select
import customSelect from 'custom-select';
import 'custom-select/build/jquery.custom-select.min.js';

// filter
let filter = $('.filter__list');
window.localStorage.setItem('filter-id', '');

filter.customSelect();
filter.on('change', (e) => {
    
    let thisFilter = $(e.currentTarget);
    let $list = thisFilter.data('list');

    filter.not(thisFilter).customSelect('value', '');
    window.localStorage.setItem('filter-id', e.currentTarget.value);
    
    // update list
    // loader.updateList($list);

    // update grid
    loader.updateGrid($list);

});

// team-list
import { Teamlist } from './modules/teamlist';
let team = new Teamlist();
